<template>
  <div class="form-container">
    <el-form label-width="130px" :model="form" :rules="rules" ref="form">
      <el-form-item label="油站名称">
        {{ userInfo.gasName }}
      </el-form-item>
      <el-form-item label="活动开始时间" prop="beginDate">
        <el-date-picker
          v-model="form.beginDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="startTimeOption">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="活动结束时间" prop="endDate">
        <el-date-picker
          v-model="form.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="endTimeOption">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="手机号" prop="payeePhone">
        <el-input placeholder="请输入手机号" v-model="form.payeePhone"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="payeeName">
        <el-input placeholder="请输入姓名" v-model="form.payeeName" maxlength="10"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="payeeCard">
        <el-input placeholder="请输入身份证号" v-model="form.payeeCard"></el-input>
        <div class="card-tips">* 填入的身份证号必须与绑定的微信的实名认证身份证号一致</div>
      </el-form-item>
    </el-form>
    <div class="btn-groups">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" @click="next">下一步</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validator from '@/utils/validate'
import dayjs from 'dayjs'
import { checkDate } from '@/api/marketPromotion'

export default {
  name: 'first',
  data () {
    let _this = this
    const checkEndTime = (rule, value, callback) => {
      if (this.form.beginDate > this.form.endDate) {
        callback(new Error('结束时间不能小于开始时间'))
      } else {
        callback()
      }
    }
    return {
      startTime: '',
      endDate: '',
      form: {
        beginDate: '',
        endDate: '',
        payeePhone: '',
        payeeName: '',
        payeeCard: ''
      },
      rules: {
        beginDate: [{ required: true, message: '请选择活动开始时间', trigger: 'change' }],
        endDate: [
          { required: true, message: '请选择活动结束时间', trigger: 'change' },
          { validator: checkEndTime, trigger: 'change' }
        ],
        payeePhone: [
                { required: true, message: '收款人手机号不能为空', trigger: 'blur' },
                { validator: validator.checkPhone, trigger: 'blur' }
              ],
        payeeName: [{ required: true, message: '收款人姓名不能为空', trigger: 'blur' }],
        payeeCard: [{ required: true, validator: validator.validateIdCard, trigger: 'blur' }]
      },
      startTimeOption: {
        disabledDate(time) {
          return dayjs(time).valueOf() < dayjs(_this.startTime).subtract(1, 'day').valueOf()
        }
      },
      endTimeOption: {
        disabledDate(time) {
          return dayjs(time).valueOf() > dayjs(_this.endDate).valueOf()
        }
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  methods: {
    next () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('submit', this.form)
        }
      })
    }
  },
  async beforeCreate() {
    const {code, result} = await checkDate({typeCode: 'deliver.water'})
    if (code !== 200) return
    this.startTime = result.startTime
    this.endDate = result.endDate
  },
}
</script>
<style lang="less" scoped>
  .form-container {
    width: 460px;
    margin-top: 30px;
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: 100%;
    }
    .card-tips {
      font-size: 12px;
      color: #999999;
    }
    .btn-groups {
      margin-top: 50px;
      text-align: center;
      .el-button {
        width: 120px;
      }
    }
  }
</style>
